var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.001,
    height: 16,
    viewBox: "0 0 11.001 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "y3bq01ao9a",
    x1: 1.212,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a8a8a"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M8.6 16a.431.431 0 0 1-.267-.114l-2.889-2.4L2.645 15.9a.406.406 0 0 1-.553-.018.351.351 0 0 1-.109-.262l-.305-6.126a6.339 6.339 0 0 0 .582.411 6.167 6.167 0 0 0 6.481 0 6.387 6.387 0 0 0 .571-.411l-.305 6.149a.38.38 0 0 1-.386.357zM2.477 9.587a5.072 5.072 0 0 1-.868-8.061 5.724 5.724 0 0 1 7.783 0A5.13 5.13 0 0 1 11 5.229a5.38 5.38 0 0 1-5.524 5.225 5.614 5.614 0 0 1-2.999-.867z",
    style: {
      fill: "url(#y3bq01ao9a)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverIcon);
export default __webpack_public_path__ + "static/media/silver-icon.acfaa8e04444750f4cb2c6823adfe708.svg";
export { ForwardRef as ReactComponent };